import { ALL_OPERATORS_CONFIG } from './comparatorConfig';
import { ALL_COMPARATORS } from './comparators';
import { ALL_DATA_TYPES } from './dataTypes';

export const DEFAULT_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
] as const;

export const NUMBER_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.less_than_or_equal_to],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.greater_than_or_equal_to],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.between],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain],
] as const;

export const STRING_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.starts_with],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.ends_with],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contains_data],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain_data],
] as const;

export const DATETIME_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.before],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.after],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_defined],
] as const;

export const BOOLEAN_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_true],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_false],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
] as const;

export const DATE_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_defined],
] as const;

export const DROPDOWN_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_defined],
] as const;

export const REFERENCE_USER_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
] as const;

export const MULTI_SELECT_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_not_defined],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.is_defined],
] as const;

export const DATE_INPUT_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.all_time],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.custom],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.yesterday],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.today],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.tomorrow],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_week],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.this_week],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.next_week],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_month],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.this_month],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.next_month],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_days],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.next_n_days],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_hours],
];

export const SECONDARY_FILTER_DATE_INPUT_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.all_time],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.custom],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.yesterday],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.today],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_week],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.this_week],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_month],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.this_month],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_days],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_hours],
];

export const ACTIVITY_NOTE_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contains_data],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain_data],
] as const;

export const DATA_TYPE_TO_OPTIONS_MAP = {
  [ALL_DATA_TYPES.number]: NUMBER_KEY_OPTIONS,
  [ALL_DATA_TYPES.string]: STRING_KEY_OPTIONS,
  [ALL_DATA_TYPES.boolean]: BOOLEAN_KEY_OPTIONS,
  [ALL_DATA_TYPES.datetime]: DATETIME_KEY_OPTIONS,
  [ALL_DATA_TYPES.date]: DATE_KEY_OPTIONS,
  [ALL_DATA_TYPES.dropdown]: DROPDOWN_KEY_OPTIONS,
  [ALL_DATA_TYPES.reference_lead_stage]: DROPDOWN_KEY_OPTIONS,
  [ALL_DATA_TYPES.reference_lead_source]: DROPDOWN_KEY_OPTIONS,
  [ALL_DATA_TYPES.multi_select]: MULTI_SELECT_KEY_OPTIONS,
  [ALL_DATA_TYPES.reference_user]: REFERENCE_USER_KEY_OPTIONS,
  [ALL_DATA_TYPES.activity_note]: ACTIVITY_NOTE_KEY_OPTIONS,
  [ALL_DATA_TYPES.default]: DEFAULT_KEY_OPTIONS,
} as const;

export const DATE_INPUT_BEFORE_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.today],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.yesterday],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.custom],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_days],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.last_n_hours],
];

export const DATE_INPUT_AFTER_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.today],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.yesterday],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.custom],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.next_n_days],
];

export const ACTIVITY_HIDDEN_KEY_OPTIONS = [
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.contains_data],
  ALL_OPERATORS_CONFIG[ALL_COMPARATORS.does_not_contain_data],
] as const;
